import { useListContext, Button, useUnselectAll, useResourceContext } from "react-admin";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useState } from "react";
import CustomDialog from "../../utils/CustomDialog";
import CallMergeIcon from '@mui/icons-material/CallMerge';
import { useEffect } from "react";

export const MergeAccountsBulkButton = ({ bankDataMap, onMerge, dataRefreshedSignal }) => {
    const { selectedIds, data } = useListContext();
    const [open, setOpen] = useState(false);
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
    const [mergeTarget, setMergeTarget] = useState(null);
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const resource = useResourceContext();
    const unselectAll = useUnselectAll(resource);

    function cleanup() {
        setSelectedAccounts([]);
        setMergeTarget(null);
        unselectAll();
    }

    // this is required as data is refreshed but the selection is not cleared
    // also this will take care of if the accounts are merged the selection will be cleared
    useEffect(() => {
        cleanup();
    // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [dataRefreshedSignal]);

    const handleSubmit = async () => {
        try {
            setSubmitButtonLoading(true);
            await onMerge(selectedAccounts, mergeTarget);
            setOpen(false);
            cleanup();
        } catch (error) {
            // do nothing
        }
        setSubmitButtonLoading(false);
    };

    const openMergeDialog = () => {
        if (selectedIds) {
            setSelectedAccounts(selectedIds
                .map(id => data.find(account => account.id === id))
                .filter(Boolean));
        }
        setOpen(true);
    };

    const rowHeaderStyle = {
        backgroundColor: "#f2f2f2",
        boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)"
    };

    const rowStyle = {
        borderBottom: "1px solid #ddddddff"
    };

    const cellStyle = {
        padding: "8px",
        textAlign: "center",
        fontSize: "0.875rem",
        fontWeight: 300
    };

    const headerCellStyle = {
        padding: "8px",
        textAlign: "center",
        fontSize: "0.875rem",
        fontWeight: 700,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        backgroundColor: "#e2e2e2ff",
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 3px 2px 0px"
    };

    return (
        <>
            <Button
                id="matters-merge-accounts-open"
                onClick={openMergeDialog}
                disabled={selectedIds.length <= 1
                }
            >
                Merge accounts
            </Button>
            <CustomDialog
                openDialog={open}
                closeDialog={() => setOpen(false)}
                title="Merge Accounts"
                submitBtnIcon={<CallMergeIcon />}

                content={
                    <RadioGroup
                        value={mergeTarget}
                        onChange={e => setMergeTarget(e.target.value)}
                    >
                        <p>Select the account to merge into:</p>
                        <p style={{ color: "#730023" }}>Note: Merging accounts is irreversible.</p>
                        <table style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            border: "1px solid #ddd",
                            textAlign: "left",
                        }}>
                            <thead>
                                <tr style={rowHeaderStyle}>
                                    <th style={headerCellStyle}></th>
                                    <th style={headerCellStyle}>BANK</th>
                                    <th style={headerCellStyle}>ACCOUNT NUMBER</th>
                                    <th style={headerCellStyle}>SORT CODE</th>
                                    <th style={headerCellStyle}>TRANSACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedAccounts.map(acc => (
                                    <tr key={acc.accountId} style={rowStyle}>
                                        <td style={cellStyle}>
                                            <Radio id={`matters-merge-target-radio-${acc.accountId}`} value={acc.accountId} />
                                        </td>
                                        <td style={cellStyle}>{bankDataMap.get(acc.bankId)}</td>
                                        <td style={cellStyle}>{acc.accountNumber}</td>
                                        <td style={cellStyle}>{acc.sortCode}</td>
                                        <td style={cellStyle}>{acc.txnCount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </RadioGroup>
                }
                handleSubmit={handleSubmit}
                submitBtnTitle="Merge Account"
                disableSubmitButton={!mergeTarget || submitButtonLoading}
                loading={submitButtonLoading}
            />
        </>

    );
};


